<div class="btn-group" container="body" ngbDropdown role="group" aria-label="Button group with nested dropdown">
  <button class="btn btn-link float-right dropdown-no-arrow" ngbDropdownToggle title="Toggle Actions Dropdown">
    <span class="fa-solid fa-ellipsis-vertical"></span>
  </button>
  <div class="dropdown-menu" ngbDropdownMenu>
    <button ngbDropdownItem
            [disabled]="(!isAdminRole && !isSuperAdminRole) ||restrictOrganizationInteraction"
            (click)="onEditOrganization(organization)">
      <span class="fa-solid fa-pen"></span>
      <span translate>Edit</span>
    </button>
    <button ngbDropdownItem
            [disabled]="(!isAdminRole && !isSuperAdminRole) ||restrictOrganizationInteraction"
            (click)="onRedirectToConfiguration(organization)">
      <span class="fa-solid fa-gear"></span>
      <span translate>Configuration</span>
    </button>
        <button ngbDropdownItem
            [disabled]="(!isAdminRole && !isSuperAdminRole) ||restrictOrganizationInteraction"
            (click)="onResetUserAgreements(organization)">
      <span class="fa-solid fa-user"></span>
      <span translate>Reset user agreements</span>
    </button>
    <button ngbDropdownItem #deleteButton
            [disabled]="(!isAdminRole && !isSuperAdminRole) ||restrictOrganizationInteraction || organization.id === rootOrganizationId"
            [ngClass]="{'text-danger': !deleteButton.classList.contains('disabled')}"
            (click)="onDeleteOrganization(organization)">
      <span class="fa-solid fa-trash"></span>
      <span translate>Delete</span>
    </button>
  </div>
</div>
